import { type Dispatch, Fragment, type SetStateAction } from 'react'

import { Icon } from '@fv/client-components'
import type { ShipmentLocation } from '@fv/client-types'

import { RadioItem } from '../inputs/RadioField'
import { Pinline } from '../Pinline'

type Props = {
  currentSequence: number
  locations: ShipmentLocation[]
  setSequence: Dispatch<SetStateAction<string>>
}

export const UpdateTrackingSequenceForm = ({
  currentSequence,
  locations,
  setSequence,
}: Props) => {
  const sequenceOptions = buildSequenceOptions(locations)

  return (
    <div>
      <div className="update-tracking-locations">
        {sequenceOptions.map(o => {
          const id = `stop-${o.value}`

          return (
            <Fragment key={id}>
              <div className="flex items-center">
                <div className="update-tracking-location truncate flex-1">
                  <Icon icon="building" className="text-fv-gray-dark" />
                  <span>{o.location}</span>
                </div>
                <RadioItem
                  id={id}
                  value=""
                  name="trackingSequence"
                  label={o.status}
                  checked={o.value === currentSequence}
                  onChange={() => setSequence(o.value.toString())}
                  className="w-[7.5rem] border-l flex-none pl-2 border-l-fv-gray"
                />
              </div>

              {o.value < locations.length - 1 && (
                <div className="mx-0 my-2 flex items-center">
                  <Pinline className="mx-1" flex />
                  <Icon icon="arrow-down" className="text-fv-green" />
                  <Pinline className="mx-1" flex />
                </div>
              )}
            </Fragment>
          )
        })}
      </div>
    </div>
  )
}

function buildSequenceOptions(locations: ShipmentLocation[]) {
  const options = [
    {
      location: 'Ready for pickup',
      status: 'Pending',
      value: -1,
    },
  ]

  locations.forEach(x => {
    const isOrigin = x.sequence === 0
    const isDest = x.sequence === locations.length - 1

    options.push({
      location: `${x.company}, ${x.city} ${x.state} ${x.postalCode}`,
      status: isOrigin ? 'Picked Up' : isDest ? 'Delivered' : 'Completed',
      value: x.sequence,
    })
  })

  return options
}
